<template>
  <div class="h-full">
    <el-row :gutter="10" class="h-full">
      <el-col class="h-full" :span="5" id="leftCol">
        <el-card
          class="h-full"
          id="assetCard"
          :body-style="{
            overflow: 'hidden',
            padding: '20px',
            height: '100%',
            position: 'relative',
          }"
        >
          <el-row class="flex">
            <el-input
              placeholder="目录树名称"
              v-model="keyName"
              clearable
              @keyup.enter.native="getMasterDataList()"
            ></el-input>
            <el-button type="primary" class="ml-10px" @click="getMasterDataList()">{{
              $t('search')
            }}</el-button>
          </el-row>
          <el-row class="flex mt-10px">
            <div class="flex-1 title text-14px font-bold">资产目录树</div>
          </el-row>
          <el-row v-if="showCollection" id="collectBox" style="max-height: 200px; overflow-y: auto">
            <el-tree
              :data="collectionTree"
              :props="collectionProps"
              @node-click="handleCollectionClick"
              default-expand-all
              ref="collectionTree"
              node-key="treeId"
            >
              <div
                class="custom-tree-node text-overflow w-full flex flex-align-center"
                slot-scope="{ node, data }"
              >
                <el-tooltip :content="data.name" :open-delay="500" placement="top">
                  <span class="text-overflow tree-text-label flex-1">{{ data.name }}</span>
                </el-tooltip>
                <el-tooltip content="取消收藏" :open-delay="500" placement="top">
                  <span
                    v-if="data.treeId && $hasAccess('unbookmark')"
                    class="w-30px"
                    @click.stop="handleCommandTree(data.treeId, false, data.name, data.classId)"
                    ><i class="iconfont icon-bg-collection"></i
                  ></span>
                </el-tooltip>
              </div>
            </el-tree>
          </el-row>
          <el-row style="overflow-y: auto" :style="{ height: assetBoxHeight }" id="assetBox">
            <el-tree
              v-loading="loadingTree"
              v-if="mainDataList.length"
              :data="assetTree"
              :props="assetProps"
              @node-click="handleAssetClick"
              ref="assetTree"
              node-key="id"
              lazy
              :load="listByClassIds"
            >
              <div
                class="custom-tree-node text-overflow w-full flex flex-align-center"
                slot-scope="{ node, data }"
              >
                <el-tooltip :content="data.name" :open-delay="500" placement="top">
                  <span class="text-overflow tree-text-label flex-1">{{ data.name }}</span>
                </el-tooltip>
                <el-tooltip content="收藏" :open-delay="500" placement="top">
                  <span
                    v-if="data.isChild && !data.isCollect && $hasAccess('collect')"
                    class="w-30px"
                    @click.stop="handleCommandTree(data.id, true, data.name, data.classId)"
                    ><i class="iconfont icon-line-collection"></i
                  ></span>
                </el-tooltip>
              </div>
            </el-tree>
            <div v-else class="h-full flex-center">暂无数据</div>
          </el-row>
          <div class="toLeft" v-if="showLeft" @click="isShowLeft">
            <i class="iconfont icon-bg-circleLeft text-30px"></i>
          </div>
        </el-card>
      </el-col>
      <el-col :span="5" class="h-full">
        <el-card
          class="h-full"
          :body-style="{ padding: '20px', height: 'calc(100% - 45px)', position: 'relative' }"
        >
          <div slot="header">
            <div class="text-center text-overflow">{{ currentTreeName }}</div>
          </div>
          <div class="h-full w-full" id="tree" v-loading="treeLoading">
            <VirtualTree
              :highlight-current="true"
              :data="treeData"
              :props="defaultProps"
              :treeStyle="{
                maxHeight: heightObj.maxHeight,
                minHeight: heightObj.minHeight,
                overflowY: 'auto',
              }"
              class="w-full"
              emptyText="暂无数据"
              accordion
              @node-click="handleNodeClick"
              :expand-on-click-node="false"
              lazy
              :load="loadNode"
            >
              <div
                class="custom-tree-node text-overflow w-full d-flex flex-align-center"
                slot-scope="{ node, data }"
              >
                <span class="text-overflow tree-text-label fz-12">{{ data.name }}</span>
              </div>
            </VirtualTree>
          </div>
          <div class="toRight" v-if="!showLeft" @click="isShowLeft">
            <i class="iconfont icon-bg-circleRight text-30px"></i>
          </div>
        </el-card>
      </el-col>
      <el-col class="h-full" :span="14" id="rightCol">
        <el-card
          class="h-full"
          :body-style="{ overflow: 'hidden', padding: '20px', height: '100%' }"
        >
          <div class="flex" ref="menuTop">
            <el-input
              size="small"
              v-model="primaryAttributeDataFilter"
              clearable
              class="w-200px mr-10px"
              placeholder="请输入主键搜索"
            >
            </el-input>
            <el-input
              size="small"
              clearable
              v-model="nameAttributeDataFilter"
              :placeholder="$t('请输入名称搜索')"
              class="w-200px mr-10px"
            >
            </el-input>
            <!-- <el-select
              size="small"
              clearable
              v-model="symbolValue"
              :placeholder="$t('请选择关联数据表')"
              class="w-200px mr-10px"
              filterable
            >
            </el-select>
            <el-select
              size="small"
              clearable
              v-model="symbolValue"
              class="w-200px mr-10px"
              filterable
            >
              <el-option label="已关联" :value="0"></el-option>
              <el-option label="未关联" :value="1"></el-option>
              <el-option label="全部" :value="2"></el-option>
            </el-select> -->
            <el-button type="primary" @click="getClassDataByTree">搜索</el-button>
            <el-button @click="download" :loading="downloadLoading">下载</el-button>
            <!-- <columnVisible
              :options="columnVisibleOptions"
              ref="columnVisible"
              class="dib ml-10px"
              :name="['assetCatalogueColumnVisible']"
              :defaultValue="columnVisible"
              @columnVisibleChanged="changeColumn"
            ></columnVisible> -->
          </div>
          <el-tabs style="height: calc(100% - 36px)" v-model="activeTab" v-loading="isTableLoading">
            <el-tab-pane
              :label="item.name"
              :name="item.id"
              class="h-full"
              v-for="(item, index) in _.cloneDeep(tabList).splice(0, showItemNum)"
              :key="index"
            >
              <el-table
                :data="tableData"
                ref="table"
                @row-dblclick="toDetail"
                @sort-change="headerClick($event)"
                border
                height="calc(100% - 50px)"
              >
                <el-table-column
                  sortable
                  v-for="(val, index) in dynamicFilterHeader"
                  :prop="val.columnName"
                  :label="val.name"
                  :key="index"
                  min-width="180"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row[`${val.columnName}`] === true">
                      <span style="color: #00a5fb;font-size: 20px">√</span>
                    </div>
                    <div v-else-if="scope.row[`${val.columnName}`] === false">
                      <span style="color: #f14c40;font-size: 20px">×</span>
                    </div>
                    <div v-else class="truncate">
                      {{ scope.row[`${val.columnName}`] }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="`${$t('operate')}`" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button @click.stop="toDetail(scope.row)" size="mini">{{
                      $t('view')
                    }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="tableParams.pageno"
                :page-sizes="$pageSizeAll"
                :page-size.sync="tableParams.pagesize"
                layout="->, total, sizes, prev, pager, next"
                :total="pageTotal"
                class="mt-20px"
              ></el-pagination>
            </el-tab-pane>
            <el-tab-pane
              :name="moreTab"
              v-if="tabList.length > showItemNum"
              class="h-full"
              disabled
            >
              <span slot="label">
                <el-dropdown>
                  <div
                    class="cursor-pointer font-900 iconfont icon-line-moreHorizontal text-[#333]"
                  ></div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      @click.native="clickTab(it)"
                      :class="{ 'text-active-dropdown': it.id === activeTab }"
                      v-for="(it, index) in _.cloneDeep(tabList).splice(
                        showItemNum,
                        tabList.length - 1
                      )"
                      :key="index"
                      >{{ it.name }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
              <el-table
                :data="tableData"
                ref="table"
                @row-dblclick="toDetail"
                @sort-change="headerClick($event)"
                border
                height="calc(100% - 50px)"
              >
                <el-table-column
                  sortable
                  v-for="(val, index) in dynamicFilterHeader"
                  :prop="val.columnName"
                  :label="val.name"
                  :key="index"
                  min-width="180"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row[`${val.columnName}`] === true">
                      <i class="icon-bg-selected"></i>
                    </div>
                    <div v-if="scope.row[`${val.columnName}`] === false">
                      <i class="icon-line-close"></i>
                    </div>
                    <div v-else class="truncate">
                      {{ scope.row[`${val.columnName}`] }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="`${$t('operate')}`" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-button @click.stop="toDetail(scope.row)" size="mini">{{
                      $t('view')
                    }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="tableParams.pageno"
                :page-sizes="$pageSizeAll"
                :page-size.sync="tableParams.pagesize"
                layout="->, total, sizes, prev, pager, next"
                :total="pageTotal"
                class="mt-20px"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>

    <!-- 查看文件 -->
    <el-dialog
      :width="uploadFileTitle === $t('upload') ? '400px' : '1200px'"
      :top="isFullScreen ? '0' : '15vh'"
      id="viewDialog"
      :title="uploadFileTitle"
      :visible.sync="uploadFileVisible"
    >
      <i
        @click="fullScreen()"
        v-show="uploadFileTitle !== $t('upload')"
        v-if="!isFullScreen"
        class="iconfont icon-fullscreen cur-pointer position-absolute"
      ></i>
      <i
        v-show="uploadFileTitle !== $t('upload')"
        @click="exitFullScreen()"
        v-else
        class="iconfont icon-fullscreen cur-pointer position-absolute"
      ></i>
      <div style="height: 520px" id="fileView" v-loading="loadingFile">
        <img :src="viewUrl" class="w-full h-full" v-if="isImg" />
        <iframe v-else :src="viewUrl" class="w-full h-full"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import ColumnVisible from '@/components/ColumnVisible'
import VirtualTree from '@/components/virtualScrollTree/tree'
import assetService from '@/services/assetService'
import MasterDataManageService from '@/services/masterDataManageService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import fnMixin from '@/assets/js/fnMixins'

export default {
  components: {
    VirtualTree,
    // ColumnVisible,
  },
  mixins: [fnMixin],
  data() {
    return {
      nameAttributeDataFilter: '',
      primaryAttributeDataFilter: '',
      mainDataList: [],
      keyName: '',
      loadingTree: false,
      selectedId: '',
      browseItem: '',
      uploadFileTitle: '',
      uploadFileVisible: false,
      isFullScreen: false,
      loadingFile: false,
      viewUrl: '',
      isImg: false,
      currentMainDataName: '', // 当前主数据name
      currentMainDataId: '', // 当前主数据id
      entityList: [], // 实体列表
      currentEntityId: '', // 当前实体id
      showLeft: true,
      showCollection: true,
      assetBoxHeight: '200px',
      collectionTree: [
        {
          name: '收藏夹',
          children: [],
        },
      ],
      collectionProps: {
        children: 'children',
        label: 'name',
      },
      assetTree: [
        {
          name: '资产目录树',
          children: [],
        },
      ],
      assetProps: {
        children: 'children',
        label: 'name',
      },
      classListLoading: false,
      currentAssetId: '', // 资产id
      currentAssetName: '', // 资产name
      treeData: [],
      currentTreeId: '',
      currentTreeName: '',
      defaultProps: {
        children: 'children',
        label: 'nodeName',
        isLeaf: 'isLeaf',
      },
      heightObj: {
        minHeight: '30rem',
        maxHeight: '45rem',
        isZoom: false,
      },
      treeLoading: false,
      attrId: '',
      selectedAttrType: 1,
      symbolValue: '',
      tableParams: {
        // 右边表格查询的参数
        keyword: '',
        breakdownnode: '',
        classattributeid: '',
        classattributecode: '',
        pageno: 1,
        pagesize: 15,
        breakDownId: '',
        whereConditions: '',
      },
      tableData: [],
      dynamicHeader: [],
      columnVisible: [],
      columnVisibleOptions: [],
      isTableLoading: false,
      dynamicFilterHeader: [],
      sortableNum: 0,
      pageTotal: 0, // table总共条数
      imgExt: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tif'],
      fileExt: ['pptx', 'ppt', 'xlsx', 'xls', 'doc', 'docx', 'txt'], // 转pdf的文件格式
      countNum: 1,
      tabList: [], // 实体tab
      activeTab: '', // 当前激活的tab
      totalHeader: {},
      totalData: {},
      totalCount: {},
      isSearch: true,
      currentObj: {},
      showItemNum: 7,
      moreTab: '0',
      downloadLoading: false,
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  watch: {
    // keyName() {
    //   this.getMasterDataList()
    // },
    activeTab(val) {
      if (val) {
        this.tableData = this.totalData[val]
        this.dynamicFilterHeader = this.totalHeader[val]
        this.pageTotal = this.totalCount[val]
      }
    },
    tabList: {
      handler(newVal) {
        if (this.$refs.menuTop && this.$refs.menuTop.clientWidth) {
          let totalLength = 0
          let flag = false
          const clientWidth = this.$refs.menuTop.clientWidth
          _.map(newVal, (item, index) => {
            if (index === 0) {
              totalLength = 14 * item.name.length + 20 + totalLength
            } else {
              totalLength = 14 * item.name.length + 20 * 2 + totalLength
            }
            if (totalLength <= clientWidth) {
              this.showItemNum = newVal.length
            }
            if (totalLength > clientWidth && !flag) {
              this.showItemNum = index + 1
              flag = true
            }
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async download() {
      this.downloadLoading = true
      const res = await assetService.downloadMasterData({
        object: this.currentObj,
      })
      this.downloadLoading = false
      if (res) {
        this.downLoadBlob({
          name: '主数据清单.xlsx',
          data: res,
        })
      }
    },
    // 获取资产目录树
    async getTreeKinds(id) {
      const params = { flag: 0, data_kind: 2, data_main_type_id: id }
      // params['name[$text]'] = this.keyName
      const res = await assetService.getTreeKinds(params)
      if (res && res.code === 0) {
        return res.data
      }
      return []
    },
    // 获取资产列表（ 通过目录树获,取实体数据 ）
    async getClassDataByTree(type) {
      this.isTableLoading = true
      if (type === 'referch') {
        this.tableParams.pageno = 1
      }
      const res = await assetService.getClassDataByMasterData({
        skipCount: (this.tableParams.pageno - 1) * this.tableParams.pagesize,
        maxResultCount: this.tableParams.pagesize,
        sorting: '',
        object: {
          ...this.currentObj,
          primaryAttributeDataFilter: this.primaryAttributeDataFilter,
          nameAttributeDataFilter: this.nameAttributeDataFilter,
        },
      })
      this.isTableLoading = false
      if (res && res.code === 0 && res.data) {
        this.totalHeader = res.data.classDataHeader
        this.totalData = res.data.classData
        this.totalCount = res.data.classDataCount
        this.tabList = res.data.stdClassList
        this.activeTab = this.tabList.length > 0 ? this.tabList[0].id : ''
        if (this.activeTab) {
          this.tableData = this.totalData[this.activeTab]
          this.dynamicFilterHeader = this.totalHeader[this.activeTab]
          this.pageTotal = this.totalCount[this.activeTab]
        }
      }
    },
    clickTab(val) {
      this.moreTab = val.id
      this.activeTab = val.id
    },
    handleSizeChange(size) {
      this.tableParams.pagesize = size
      this.getClassDataByTree('referch')
    },
    handleCurrentChange(num) {
      this.tableParams.pageno = num
      this.getClassDataByTree('refrech')
    },
    // 表格排序
    headerClick(event) {
      this.tableParams.orderBy = event.prop
      if (this.sortableNum === 0) {
        this.tableParams.orderByType = this.sortableNum
        this.sortableNum = 1
      } else {
        this.tableParams.orderByType = this.sortableNum
        this.sortableNum = 0
      }
    },
    changeColumn(data) {
      if (data.length === 0 && this.dynamicFilterHeader.length === 1) {
        this.$message({
          type: 'warning',
          message: '请至少选择一项表头',
        })
        return
      }
      this.columnVisible = data
      this.dynamicFilterHeader = _.filter(this.dynamicHeader, (item) => {
        return _.includes(data, item.code)
      })
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      })
    },
    // 点击目录节点
    handleNodeClick(data) {
      // this.currentEntityId = data.id
      // // 递归获取想要的数据
      // const newObj = {
      //   classattributeid: [],
      //   classattributecode: [],
      //   breakdownnode: [],
      // }
      // this.getFilterData(node, newObj)
      // _.forIn(newObj, (val, key) => {
      //   newObj[key] = _.join(val, ',')
      // })
      // _.assign(this.tableParams, newObj, {
      //   breakDownId: data.breakDownId,
      //   whereConditions: data.whereConditions,
      // })
      // this.tableParams.orderBy = data.classAttributeCode
      this.isSearch = false
      this.currentObj = data.object
      this.getClassDataByTree('referch')
    },
    // 递归循环tree节点获取想要的数据
    getFilterData(node, newObj) {
      newObj.classattributeid.push(node.data.classAttributeId)
      newObj.classattributecode.push(node.data.classAttributeCode)
      newObj.breakdownnode.push(node.data.breakDownNode)
      if (node.level === 1) {
        return false
      }
      this.getFilterData(node.parent, newObj)
    },
    // 懒加载目录树
    async loadNode(node, resolve) {
      if (node.level > 0) {
        const res = await assetService.getLazyTreeDatas(node.data.object)
        if (res && res.code === 0 && res.data) {
          return resolve(res.data)
        }
        return resolve([])
      }
      return resolve([])
    },
    // 根据classId获取资产目录树名称
    async listByClassIds(node, resolve) {
      if (node.level === 0) {
        return resolve(this.assetTree)
      }
      if (node.level === 1) {
        const parameter = {
          StandardId: '',
          typeName: this.keyName,
        }
        const res = await MasterDataManageService.getList(parameter)
        if (res && res.code === 0 && res.data) {
          const resData = _.map(res.data, (item) => {
            item.name = item.typeName
            return item
          })
          return resolve(resData)
        }
      }
      if (node.level === 2) {
        const resData = await this.getTreeKinds(node.data.id)
        _.map(resData, (cItem) => {
          if (_.find(this.collectionTree[0].children, ['treeId', cItem.id])) {
            cItem.isCollect = true
          } else {
            cItem.isCollect = false
          }
          cItem.isChild = true
          return cItem
        })
        return resolve(resData)
        // if (node.data.classInfo === null) {
        //   return resolve([])
        // }
        // const ids = _.map(node.data.classInfo, (item) => {
        //   return item.classId
        // })
        // const res = await MasterDataManageService.listByClassIds(ids)
        // if (res && res.code === 0 && !_.isEmpty(res.data)) {
        //   const resData = res.data
        //   _.map(resData, (cItem) => {
        //     if (_.find(this.collectionTree[0].children, ['treeId', cItem.id])) {
        //       cItem.isCollect = true
        //     } else {
        //       cItem.isCollect = false
        //     }
        //     cItem.isChild = true
        //     return cItem
        //   })
        //   if (this.countNum === 1) {
        //     this.handleAssetClick(resData[0])
        //     this.$nextTick(() => {
        //       this.$refs.assetTree.setCurrentKey(resData[0].id)
        //     })
        //   }
        //   this.countNum = this.countNum + 1
        //   return resolve(resData)
        // }
      }
      return resolve([])
    },
    // 根据资产目录id获取tree数据
    async getTreeData() {
      const treeHeigh = document.getElementById('tree').offsetHeight
      if (treeHeigh > 0) {
        this.heightObj.maxHeight = `${treeHeigh / 16}rem`
      }
      this.treeLoading = true
      const params = {
        structureBreakdownId: this.currentTreeId,
        skipCount: 0,
        maxResultCount: 100,
        sorting: '',
      }
      const resTree = await assetService.getFirstTreeById(params)
      if (resTree && resTree.code === 0 && resTree.data) {
        // withhierarchy = 1 不请求下一级菜单
        this.treeData = resTree.data
        // this.treeData = _.map(resTree.data, (item) => {
        //   item.isLeaf = item.withhierarchy === 1
        //   return item
        // })
        this.treeLoading = false
        // 初始化时根据树形列表的第一项的classAttributeCode 查询资产列表
        if (resTree.totalCount > 100) {
          const res = await assetService.getFirstTreeById({
            structureBreakdownId: this.currentTreeId,
            skipCount: 0,
            maxResultCount: resTree.totalCount,
            sorting: '',
          })
          if (res && res.code === 0 && res.data) {
            this.treeData = res.data
            // this.treeData = _.map(res.data, (item) => {
            //   item.isLeaf = item.withhierarchy === 1
            //   return item
            // })
          }
        }
        if (resTree.data.length) {
          this.tableParams.orderBy = resTree.data[0].classAttributeCode
        }
        return
      }
      this.treeLoading = false
    },
    handleCommandTree(id, val, name, classId) {
      this.updateCollection(val, id, name, classId)
    },
    // 获取收藏夹内容
    async getCollection() {
      const res = await stdClassDataService.getCollection({ menu: 'master-data-inventory' })
      if (res) {
        this.collectionTree[0].children = res
      }
    },
    // 收藏自己的内容
    async updateCollection(val, id, name, classId) {
      const res = await stdClassDataService.updateCollection({
        standardId: '',
        treeId: id,
        isFavorite: val,
        menu: 'master-data-inventory',
        name,
        classId,
      })
      if (res && res.code === 0) {
        if (val) {
          this.$message.success('收藏成功')
        } else {
          this.$message.success('取消收藏成功')
        }
        await this.getCollection()
        this.getMasterDataList()
      }
    },
    async handleCollectionClick(data) {
      // 取消assetTree的当前高亮节点
      this.$nextTick(() => {
        this.$refs.assetTree.setCurrentKey(null)
      })
      if (data.treeId) {
        this.currentTreeName = data.name
        this.currentTreeId = data.treeId
        this.getTreeData()
      }
    },
    handleAssetClick(data) {
      // 清空资产tab的数据
      this.tableData = []
      this.dynamicHeader = []
      this.dynamicFilterHeader = []
      this.tabList = []
      // 取消collectionTree的当前高亮节点
      this.$nextTick(() => {
        this.$refs.collectionTree.setCurrentKey(null)
      })
      if (data.dataKind) {
        this.currentTreeName = data.name
        this.currentTreeId = data.id
        this.getTreeData()
      }
    },
    // 展开和收起
    isShowLeft() {
      this.showLeft = !this.showLeft
      if (this.showLeft) {
        document.getElementById('leftCol').className = 'el-col el-col-5 h-full'
        document.getElementById('rightCol').className = 'el-col el-col-14 h-full'
      } else {
        document.getElementById('leftCol').className = 'el-col el-col-0'
        document.getElementById('rightCol').className = 'el-col el-col-19 h-full'
      }
    },
    exitFullScreen() {
      this.isFullScreen = false
      this.exitFullscreen()
      if (this.uploadFileTitle === this.$t('upload')) {
        $('#viewDialog .el-dialog')
          .width(400)
          .height(280)
        $('#fileView').height(215)
        return
      }
      $('#viewDialog .el-dialog')
        .width(1200)
        .height(600)
      $('#fileView').height(515)
    },
    // 判断浏览器种类
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    fullScreen() {
      this.isFullScreen = true
      this.launchFullscreen(document.getElementById('viewDialog'))
    },
    // 判断各种浏览器，找到正确的方法
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
      $('#viewDialog .el-dialog')
        .width(window.screen.width)
        .height(window.screen.height)
      $('#fileView').height(window.screen.height - 100)
    },
    async getFileId(id) {
      // 1.先通过当前记录的id拿到fileId
      const res = await assetService.getFileId({ ownerId: this.selectedId, stepId: id })
      if (res.length > 0) {
        this.browseItem = res[res.length - 1]
      } else {
        this.browseItem = null
      }
    },
    async viewFile(row, column) {
      this.selectedId = row.id
      let stdClassAttributeId = null
      _.map(this.attrList, (item) => {
        if (item.columnName === column) stdClassAttributeId = item.stdClassAttributeId
      })
      await this.getFileId(stdClassAttributeId)
      if (this.browseItem !== null) {
        $('#viewDialog .el-dialog').height(600)
        this.uploadFileTitle = this.$t('view')
        this.uploadFileVisible = true
        this.loadingFile = true
        // 通过fileId拿到返回的文件流
        if (_.includes(this.imgExt, this.browseItem.fileType.split('.')[1])) {
          // png
          this.isImg = true
          const resData = await assetService.browsePNG({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'image/jpeg' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        } else {
          // pdf
          this.isImg = false
          const resData = await assetService.browsePDF({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        }
      } else {
        this.$message.warning('没有上传文件')
      }
    },
    /**
     * @function 获取主数据清单列表
     */
    async getMasterDataList(id, name) {
      const assetCard = document.getElementById('assetCard').offsetHeight
      if (this.keyName === '' || this.keyName === null) {
        this.showCollection = true
        const collectBox = document.getElementById('collectBox')
          ? document.getElementById('collectBox').offsetHeight
          : 0
        this.assetBoxHeight = `${assetCard - collectBox - 100}px`
      } else {
        this.showCollection = false
        this.assetBoxHeight = `${assetCard - 100}px`
      }
      const parameter = {
        StandardId: '',
        typeName: this.keyName,
      }
      this.loadingTree = true
      const res = await MasterDataManageService.getList(parameter)
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.mainDataList = _.map(res.data, (item) => {
          item.name = item.typeName
          item.children = item.classInfo
          return item
        })
        this.assetTree = [
          {
            name: '资产目录树',
            children: this.mainDataList,
          },
        ]
        if (id) {
          this.currentTreeId = id
          this.currentTreeName = name
        } else {
          console.log(555, this.mainDataList)
        }
        // else {
        //   this.currentMainDataId = this.mainDataList[0].children.length
        //     ? this.mainDataList[0].children[0].id
        //     : this.mainDataList[1].children[0].id
        //   this.currentMainDataName = this.mainDataList[0].children.length
        //     ? this.mainDataList[0].children[0].name
        //     : this.mainDataList[1].children[0].name
        // }
        this.$nextTick(() => {
          this.$refs.assetTree.setCurrentKey(this.currentMainDataId)
        })
        if (this.$route.query.currentTreeId && this.entityList.length > 0) {
          this.currentEntityId = this.entityList[0].classId
          this.currentAssetId = this.$route.query.currentTreeId
          this.currentAssetName = this.$route.query.currentTreeName
        } else if (!this.$route.query.currentTreeId && this.entityList.length > 0) {
          this.currentEntityId = this.entityList[0].classId
          this.currentAssetId = this.entityList[0].id
          this.currentAssetName = this.entityList[0].name
        } else {
          this.currentEntityId = ''
          this.currentAssetId = ''
          this.currentAssetName = ''
          this.attrList = []
        }
        this.loadingTree = false
      } else {
        this.mainDataList = []
        this.assetTree[0].children = []
        this.loadingTree = false
      }
    },
    // 查看详情页面
    toDetail(val) {
      this.$router.push({
        path: `${this.basePath}/legacy-resource/data-asset-management/asset-view`,
        query: {
          id: val.id,
          classId: this.activeTab,
          currentTreeId: this.currentTreeId,
          currentTreeName: this.currentTreeName,
          pageType: 'masterData',
        },
      })
    },
  },
  async created() {
    this.countNum = 1
    await this.getCollection()
    await this.getMasterDataList(this.$route.query.currentTreeId, this.$route.query.currentTreeName)
  },
}
</script>

<style lang="scss" scoped>

.icon-fullscreen {
  top: 12px;
  right: 45px;
}
.list-title {
  border-left: 2px solid #3686ef;
}
.list-item {
  font-size: 12px;
  padding: 5px 10px;
  position: relative;
  .display_type {
    position: absolute;
    right: 0;
  }
}
.list-item:hover,
.current-item {
  background-color: #dfecfc;
}
.current-item {
  background-color: #dfecfc;
}
.input-width {
  width: 200px;
}

body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.active {
  background: var(--tableSelectColor);
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.el-card__header {
  padding: 10px !important;
}
.icon-bg-circleLeft:before {
  color: var(--buttonPrimaryBg);
}
.icon-bg-circleRight:before {
  color: var(--buttonPrimaryBg);
}
.icon-line-collection:before {
  color: var(--buttonPrimaryBg);
}
.icon-bg-collection:before {
  color: var(--buttonPrimaryBg);
}
.toLeft {
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.toRight {
  position: absolute;
  top: 50%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-tabs .el-tabs__content {
  height: calc(100% - 55px);
}

</style>
